import SelectOrganizationComp from "../../components/pages/select-organization";

function SelectOrganization() {
  return <SelectOrganizationComp />;
}
export default SelectOrganization;
